module.exports = __webpack_public_path__ + "static/media/smile-icon.d2dc6940.svg";